<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon medium color="#fff">not_interested</v-icon>
          </div>
          <h1 style="display: inline">Suspender Servicio</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card flat class="border-container">
              <v-card-text>
                <v-flex xs12>
                  <div
                    class="mr-3"
                    :style="{
                      padding: '8px',
                      display: 'inline-block',
                      backgroundColor: '#ef565c',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <img
                      :src="require('@/assets/icons/office_building.svg')"
                      alt=""
                    />
                  </div>
                  <spab style="display: inline">{{ college.name }}</spab>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <span class="mt-2">Datos del Administrador</span>
                    <div class="border-container mt-2">
                      <span class="ml-2 mt-2 text-disabled"
                        >Nombre del Administrador</span
                      >
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        filled
                        disabled
                        v-model="college.administrator.firstName"
                      ></v-text-field>
                    </div>

                    <v-layout row wrap>
                      <v-flex xs12 sm12>
                        <div class="border-container mt-2">
                          <span class="ml-2 mt-2 text-disabled"
                            >Correo del Administrador</span
                          >
                          <v-text-field
                            hide-details
                            solo
                            flat
                            rounded
                            filled
                            disabled
                            v-model="college.administrator.email"
                          ></v-text-field>
                        </div>
                      </v-flex>
                      <!-- <v-flex xs12 sm12>
                      <span class="mt-2">Periodo de suspensión</span>
                      <v-layout row wrap>
                        <v-flex xs6 sm3 class="mb-3">
                          <v-checkbox
                            v-model="indefinido"
                            :label="`Indefinido`"
                            color="red"
                            class="ml-2"
                        
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-checkbox
                            v-model="periodo"
                            :label="`Periodo`"
                            color="red"
                           
                           hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                          <div class="border-section pa-3 mt-2">
                             <v-layout row wrap align-center>
                                <v-flex xs2  sm2 pr-0>Desde</v-flex>
                                <v-flex xs6 sm4 pl-0 ml>
                                <v-menu
                                    
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="190px"
                                >
                                    <template late v-slot:activator="{ on }">
                                    <v-text-field
                                        id="first-small"
                                        :value="momentFormatFirst"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    header-color="primary"
                                    color="secondary"
                                    locale="es-419"
                                    v-model="filters.from"
                                    scrollable
                                    ></v-date-picker>
                                </v-menu>
                                </v-flex>
                                <v-flex xs3>
                                <v-layout  class="datepicker-container">
                                    <v-icon
                                    >
                                    schedule
                                    </v-icon>
                                    <vue-timepicker
                                    class="pickers"
                                    full-width
                                    drop-direction="auto"
                                    format="hh:mm a"
                                    header-color="primary"
                                    manual-input
                                    close-on-complete
                                    />
                                </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap align-center>
                                <v-flex xs2  sm2 pr-0>Hasta</v-flex>
                                <v-flex xs4 sm4 pl-0 ml>
                                <v-menu
                                    
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="190px"
                                >
                                    <template late v-slot:activator="{ on }">
                                    <v-text-field
                                        id="first-small"
                                        :value="momentFormatFirst"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    header-color="primary"
                                    color="secondary"
                                    locale="es-419"
                                    v-model="filters.from"
                                    scrollable
                                    ></v-date-picker>
                                </v-menu>
                                </v-flex>
                                <v-flex xs3>
                                <v-layout  class="datepicker-container">
                                    <v-icon
                                    >
                                    schedule
                                    </v-icon>
                                    <vue-timepicker
                                    class="pickers"
                                    full-width
                                    drop-direction="auto"
                                    format="hh:mm a"
                                    header-color="primary"
                                    manual-input
                                    close-on-complete
                                    />
                                </v-layout>
                                </v-flex>
                            </v-layout>
                          </div>
                    </v-flex> -->
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <span class="mt-2"
                      >Motivo por el cual se esta suspendiendo el servicio</span
                    >
                    <div class="border-container mt-2" style="height: 80%">
                      <v-text-field
                        hide-details
                        solo
                        required
                        flat
                        dense
                        label="Recuerda añadir en este espacio el motivo"
                        v-model="$v.disable.reason.$model"
                      />
                    </div>
                    <span
                      class="error-pass"
                      v-if="submitted && !$v.disable.reason.required"
                      >El motivo es obligatorio</span
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <div class="container--btn mt-2 mb-2">
                <v-spacer></v-spacer>
                <v-btn class="custom-border" @click="cancel()" depressed outline
                  >Cancelar</v-btn
                >
                <v-btn
                  class="custom-border"
                  color="error"
                  style="font-size: 14px"
                  @click="submit"
                  depressed
                  >Suspender</v-btn
                >
              </div>
            </v-card>
          </v-flex>
          <Success
            v-model="success.modal"
            description="!Colegio suspendido con éxito!"
          />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'

import VueTimepicker from 'vue2-timepicker'
import error from '../../../../Dialogs/Error.vue'
import Success from '../components/SuccessSa.vue'

import { mapGetters } from 'vuex'
export default {
  validations: {
    disable: {
      reason: { required },
    },
  },
  components: {
    Success,
    error,
    VueTimepicker,
  },
  data: () => ({
    disable: {
      reason: '',
    },
    submitted: false,
    filters: {
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      schedule_type: '',
      attendance_type: '',
      period: '',
      search: '',
    },
    foo: 1,
    colegio: 'colegio 1',
    correo: 'Correocolegio1@gmail.com',
    nombre: 'Jane',
    apellido: 'Cooper',
    indefinido: true,
    periodo: false,
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    breadcrumbs: [
      {
        text: 'Colegios',
        disabled: false,
        href: '/es/sa/panel/colleges',
      },
      {
        text: 'Suspender Servicio',
        disabled: true,
        href: '/es/sa/panel/college/suspend',
      },
    ],
    success: {
      modal: false,
    },
  }),
  methods: {
    submit() {
      this.submitted = true
      this.$v.disable.$touch()
      if (this.$v.disable.$invalid) {
        return
      }
      let values = {
        reason: this.disable.reason,
      }
      this.$store
        .dispatch('colleges/disableCollege', {
          id_branch: this.$router.history.current.params.id,
          data: values,
        })
        .then((res) => {
          this.success.modal = true
          setTimeout(() => {
            this.success.modal = false
            this.$router.push({
              name: 'Colleges',
            })
          }, 2000)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => console.log())
    },
    cancel() {
      this.$router.push('/es/sa/panel/colleges')
    },
  },
  beforeMount() {
    if (this.college.administrator === undefined) {
      this.college.administrator = {}
    }
    if (this.college.administrator.firstName === undefined) {
      this.college.administrator.firstName = ''
    }
    if (this.college.administrator.email === undefined) {
      this.college.administrator.email = ''
    }
  },
  computed: {
    ...mapGetters({
      college: 'getCollegeSelect',
    }),
    momentFormatFirst() {
      if (this.filters.from != null) {
        return moment(this.filters.from).format('DD/MM/YYYY')
      }
      return ''
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.border-section {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}
/* ::v-deep .v-input__slot {
 min-height: unset;
 height: 35px;
}
::v-deep  .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;

    padding: 0;
} */
.radio--container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  height: 35px;
}
span {
  font-weight: 500;
}
.checks-type {
  display: flex;
  align-items: center;
}
.container--btn {
  display: flex;
  justify-content: flex-end;
}
.custom-border {
  border-radius: 0.5rem;
  background: #f44336;

  border-color: #ccc !important;
}
.color__btn-guardar {
  background: #f44336;
}
.text-disabled {
  color: rgba(0, 0, 0, 0.38);
}
.datepicker-container {
  padding: 5px;
}
.error-pass {
  color: #f44336;
}
</style>
